import { useContext, useState } from 'react'
import ModalComponent from '../../Modal'
import ButtonComponent from '../../Buttons/button-component'
import styles from './sociogram-table.module.scss'
import { useTranslation, Trans } from 'react-i18next'
import { useUpdateSociogramCourseTeacherAccess } from '@BUP/hooks/Sociogram/teachersData/useUpdateCourseTeacherAccess'
import { useQueryClient } from '@tanstack/react-query'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'
import { message } from 'antd'

const ShowTeacherResultsButton = ({ survey, loading }) => {
  const courseTeachers = survey.courseTeachers ?? []
  const courseName = survey.courses?.[0]?.name
  const courseId = survey.courses?.[0]?.id

  const grantedCount = courseTeachers.filter(
    (courseTeacher) => courseTeacher.teacherEventAccess?.hasAccess === true
  ).length
  const allGranted = courseTeachers.length > 0 && grantedCount === courseTeachers.length
  const isMultiple = courseTeachers.length > 1

  const teacherNames = courseTeachers
    .map((courseTeacher) => courseTeacher.teacherData?.user?.name)
    .join(', ')
  const teacherName = courseTeachers[0]?.teacherData?.user?.name

  const i18n = useTranslation()
  const [stateModal, setStateModal] = useState(false)
  const term = useContext(CurrentTermContext)

  const queryClient = useQueryClient()

  const { isUpdatingAccess, updateCourseTeacherAccess } = useUpdateSociogramCourseTeacherAccess({
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['sociogramteachers', term.id],
        refetchType: 'all'
      })
      setStateModal(false)

      const successKey = variables?.data?.hasAccess
        ? (isMultiple
            ? 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.showSuccessMultiple'
            : 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.showSuccess')
        : (isMultiple
            ? 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.hideSuccessMultiple'
            : 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.hideSuccess')

      message.success(
        <Trans
          i18nKey={successKey}
          values={isMultiple ? { teacherNames, teacherCount: courseTeachers.length } : { teacherName }}
          components={{
            bold: <strong />
          }}
        />
      )
    },
    onError: (err) => {
      message.error(
        i18n.t('common.resources.generic.messages.error')
      )
      console.error(err)
    }
  })

  const handleShowModal = () => {
    setStateModal(true)
  }

  const handleCloseModal = () => {
    setStateModal(false)
  }

  const handleConfirmSurvey = () => {
    const eventId = courseTeachers.find(
      (courseTeacher) => courseTeacher.teacherEventAccess?.eventId
    )?.teacherEventAccess?.eventId

    if (!eventId) {
      console.error('eventId not found for survey:', survey)
      return
    }
    updateCourseTeacherAccess({
      courseId,
      hasAccess: !allGranted,
      eventId
    })
  }

  const descriptionKey = allGranted
    ? (isMultiple
        ? 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.hideMultiple'
        : 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.hide')
    : (isMultiple
        ? 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.showMultiple'
        : 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.show')

  return (
    <div
      data-test='cell-wrapper-teacher-access-button'
      className={styles.actions_cell_wrapper}
    >
      <div className={styles.show_modal_button_wrapper}>
        <ButtonComponent
          buttonText={allGranted ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.hide')}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.show')}`}
          colorType='tertiary'
          block
          bold={false}
          onClick={() => handleShowModal(survey)}
          disabled={!courseTeachers?.length || isUpdatingAccess}
          loading={isUpdatingAccess}
        />
      </div>
      <ModalComponent
        stateModal={stateModal}
        onClickCloseModal={() => {
          handleCloseModal()
        }}
        modalTitle={<>{allGranted ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.title.hide')} ${courseName}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.title.show')} ${courseName}`}</>}
        modalDescription={
          <div className={styles.modal_description_wrapper}>
            <Trans
              i18nKey={`${i18n.t(descriptionKey)}`}
              values={isMultiple ? { teacherNames, teacherCount: courseTeachers.length } : { teacherName }}
              components={{ bold: <strong className={styles.teacher_name} /> }}
            />
          </div>
    }
        confirmButtonText={!allGranted ? i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.confirmShow') : i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.confirmHide')}
        onClickConfirm={() => handleConfirmSurvey()}
        loading={isUpdatingAccess || loading}
        dataTest='update-teacher-access'
      />
    </div>
  )
}

export default ShowTeacherResultsButton
